import axiosInstance from "../../../utils/axiosInstance"
import { BASE_URL,API_ENDPOINT_TEA_COFFEE,API_ENDPOINT_EXPORT_TEA_COFEE_DATA} from "../../../utils/constants";
import { createAsyncThunk } from "@reduxjs/toolkit";

/** API to fetch data categorywise [cuisine,dish,drink] */

const fetchTeaCoffee = createAsyncThunk("cuisines/teaCoffee", async (data, thunkAPI) => {
    try {
      const res = await axiosInstance.post(`${BASE_URL}${API_ENDPOINT_TEA_COFFEE}`, data);
      const responseData = await res.data;
      return responseData;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error?.response?.data);
    }
  });

  /** API to fetch Tea/coffee data */
  const exportTeaCoffeeData = createAsyncThunk("cuisines/exportTeaCoffeeData", async (data, thunkAPI) => {
    try {
      const res = await axiosInstance.post(`${BASE_URL}${API_ENDPOINT_EXPORT_TEA_COFEE_DATA}`, data);
      const responseData = await res.data;
      return responseData;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error?.response?.data);
    }
  });
  export { fetchTeaCoffee,exportTeaCoffeeData };